import {MethodNode} from 'procedures/ProcedureDomainTypes';
import {ProcedureNodeType} from 'procedures/ProcedureDomainTypes';
import {TaskDefinitionVersionSpec} from 'processes/dao/ProcessFlowchartConfigDAO';
import {StaticTemplateFlowchart} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {isStaticTaskSchemaNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';

export function isMethodNode(
  node: TaskDefinitionVersionSpec<unknown>
): node is TaskDefinitionVersionSpec<MethodNode> {
  return (
    (node.newProcessTaskDefinitionVersion.applicationData as MethodNode | undefined)?.type ===
    ProcedureNodeType.METHOD
  );
}

export function isNodeValidInProcedureFlowchart(node: TaskDefinitionVersionSpec<unknown>): boolean {
  // TODO(BNCH-136029): We can't fully validate here until the WF platform provides the task schema. Without it, we'll miss ROOT nodes
  return true;
}

export function extractMethodNodesFromStaticFlowchart(
  staticFlowchart: StaticTemplateFlowchart
): Array<MethodNode> {
  return staticFlowchart.nodesStaticData
    .filter((node) => isStaticTaskSchemaNodeData(node))
    .filter((node) => isMethodNode(node.taskDefinitionVersionSpec))
    .flatMap(
      (node) => node.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.applicationData as MethodNode
    );
}
